// Fetch z przeglądarki nie dokleja automatycznie basePath z next.config.js,
// więc ścieżki do route handlerów trzymamy tu z prefiksem.
const BASE_PATH = "/klubmedyka";

export const WESUB_ORDER_API_PATH = `${BASE_PATH}/api/wesub/order`;

export function wesubOrderStatusApiPath(rentUPOrderId: string): string {
  return `${WESUB_ORDER_API_PATH}/${encodeURIComponent(rentUPOrderId)}/status`;
}
